import { useQuery } from 'react-query'; 
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';

const fetchNotificationById = async ({ queryKey }) => {
  const [, { token, notificationId }] = queryKey; 
  const url = `${process.env.REACT_APP_SERVER_URL}/notification/${notificationId}`;
  
  console.log('Fetching notification with URL:', url);

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`, 
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    console.error('Fetch error:', response.status, response.statusText);
    throw new Error(`Network response was not ok (${response.status})`);
  }

  const result = await response.json();
  console.log('Fetched notification:', result);

  if (!result.data) {
    throw new Error('Notification not found');
  }

  return result; 
};

// Custom hook to fetch notification by ID
export const useNotificationById = (notificationId) => {
  const { token } = useContext(AuthContext); 

  return useQuery(
    ['notification', { token, notificationId }], 
    fetchNotificationById, 
    {
      enabled: !!token && !!notificationId, 
      retry: false, // Disable retries if the notification is not found
    }
  );
};
